module.exports = __webpack_public_path__ + "fc5170932e90c6bb7e36da8665b986b2.woff";